import React from "react";
import CommonSelect from "../../../components/forms/CommonSelect";
import { handleChange } from "../../../helpers/handleFormChanges";
import { meses, anos } from "../../../helpers/mesesHelper";
import PropTypes from "prop-types";

function ContasFiltros({ filtrosHook }) {
  const { filtros, setFiltros } = filtrosHook;
  const anos_disponiveis = anos();

  return (
    <div className="row">
      <div className="col-md-3">
        <div className="mb-3">
          <CommonSelect
            label="Mês"
            id="mes"
            value={filtros.mes}
            onChange={(e) => handleChange(e, filtros, setFiltros)}
            data={Object.keys(meses).map((id) => ({
              text: meses[id],
              id: id,
            }))}
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="mb-3">
          <CommonSelect
            label="Ano"
            id="ano"
            value={filtros.ano}
            onChange={(e) => handleChange(e, filtros, setFiltros)}
            data={Object.keys(anos_disponiveis)
              .reverse()
              .map((id) => ({
                text: anos_disponiveis[id],
                id: id,
              }))}
          />
        </div>
      </div>
    </div>
  );
}

ContasFiltros.propTypes = {
  filtrosHook: PropTypes.shape({
    filtros: PropTypes.object.isRequired,
    setFiltros: PropTypes.func.isRequired,
  }).isRequired,
};

export default ContasFiltros;
